// Dev-only mock config — defines the target shape for the lead dev to hook up via componentStore
export default {
    psp: 'vol',
    tabs: [
        {
            id: 'tab_overview',
            label: 'Overview',
            cards: [
                {
                    id: 'card_personal_info',
                    title: 'Personal Info',
                    type: 'fields',
                    fields: ['VOL_FIRST_NAME', 'VOL_LAST_NAME', 'VOL_BIRTH_DATE', 'VOL_GENDER'],
                    position: {
                        row: 0, col: 0, sizeX: 3, sizeY: 2
                    }
                },
                {
                    id: 'card_contact',
                    title: 'Contact',
                    type: 'fields',
                    fields: ['VOL_EMAIL', 'VOL_MOBILE', 'VOL_HOME', 'VOL_ADDRESS', 'VOL_CITY', 'VOL_STATE', 'VOL_ZIPCODE'],
                    position: {
                        row: 0, col: 3, sizeX: 3, sizeY: 2
                    }
                },
                {
                    id: 'card_availability',
                    title: 'Availability',
                    type: 'fields',
                    fields: ['VOL_AVAILABILITY'],
                    position: {
                        row: 2, col: 0, sizeX: 6, sizeY: 2
                    }
                },
            ]
        }
    ]
};
